import type { FaireProductEntity } from "../../entity_types/product";

export const p_37ueh9mj72: FaireProductEntity = {
  token: "p_37ueh9mj72",
  type: "product",
  name: "TRUFF Hot Sauce - 6 Bottles",
  brandToken: "b_6mf9sigd9i",
  brandName: "TRUFF",
  imageUrl:
    "https://cdn.faire.com/fastly/fd89e968c8c11097999c613e704252705d7070bdc48a2af54d2ed769cd1c6cd5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82ba2943eeb6eb5bc95ce289e5a88dadf0e6571ce3f5fdb621e4030ea5de5f79.jpeg",
    "https://cdn.faire.com/fastly/c5bc5f3858bd4f1a2cd0af179ca1017d3f25836d03a833150afe465528b230fd.png",
    "https://cdn.faire.com/fastly/6b04369ba3f3f214c937720cd4e1ad989944846f5d144818654e871ccd82564b.jpeg",
    "https://cdn.faire.com/fastly/6d44cb53a178c8a081896e7358b2bf6372e6735473b3823da1afa370c2151588.jpeg",
    "https://cdn.faire.com/fastly/caeed44e3178e9d709aa6a2757a360e8e6d7ba43f1970fa7f51ffee62880b61d.jpeg",
    "https://cdn.faire.com/fastly/742aaf433ea933b89bc613a0e04f4c0a9283897b94d874d1ccc848f53004a4cb.jpeg",
    "https://cdn.faire.com/fastly/d01155375a2313a2926a33a140d1e62d04a62979a8a9bdefd4b6f12803727455.jpeg",
  ],
  priceDollars: 60,
  description:
    "Truff uses ripe red chili peppers infused with real black truffle, black truffle oil and agave nectar from Jalisco, Mexico. It's all tied together with a hint of cumin. This isn't the spiciest, hottest sauce on the planet. Instead, it's a rollercoaster that starts a little sweet, then turns on the heat. Not too much, but just enough for you to feel it and for people around to see you smile.\n\nCase Qty: 6 Bottles\n\nPlease note: our product labels are designed to comply with U.S. regulations. If you choose to use these labels for international markets, you assume full responsibility for ensuring compliance with your local regulations and standards.",
  tags: [],
  msrpDollars: 120,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:08.561Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
